
module.exports = {
    ANNOTATION: 'application/vnd.mendeley-annotation.1+json',
    DOCUMENT: 'application/vnd.mendeley-document.1+json',
    DOCUMENT_CLONE: 'application/vnd.mendeley-document-clone.1+json',
    DOCUMENT_LOOKUP: 'application/vnd.mendeley-document-lookup.1+json',
    DOCUMENT_TYPE: 'application/vnd.mendeley-document-type.1+json',
    DOCUMENT_WITH_FILES: 'application/vnd.mendeley-document-with-files-list+json',
    FILE: 'application/vnd.mendeley-file.1+json',
    FOLDER: 'application/vnd.mendeley-folder.1+json',
    FOLLOW: 'application/vnd.mendeley-follow.1+json',
    FOLLOW_REQUEST: 'application/vnd.mendeley-follow-request.1+json',
    FOLLOW_ACCEPT: 'application/vnd.mendeley-follow-acceptance.1+json',
    GROUP: 'application/vnd.mendeley-group+json',
    GROUP_LIST: 'application/vnd.mendeley-group-list+json',
    GROUP_SEARCH_RESULTS: 'application/vnd.mendeley-group-search-result+json',
    INSTITUTION: 'application/vnd.mendeley-institution.1+json',
    INSTITUTION_TREE: 'application/vnd.mendeley-institution-tree.1+json',
    LOCATION: 'application/vnd.mendeley-location.1+json',
    PROFILE: 'application/vnd.mendeley-profile.1+json',
    PROFILES: 'application/vnd.mendeley-profiles.1+json',
    PROFILE_UPDATE: 'application/vnd.mendeley-profile-amendment.1+json',
    SUBJECT_AREA: 'application/vnd.mendeley-subject-area.1+json',
    USER_ROLE: 'application/vnd.mendeley-user-role.1+json'
};



//////////////////
// WEBPACK FOOTER
// ./lib/mime-types.js
// module id = 40
// module chunks = 0